<script setup lang="ts">
import { computed } from 'vue';
import BaseErrorState from '../ui/BaseErrorState.vue';
import { $t } from '@/composables/translations/useTranslate.ts';

const emit = defineEmits<{
  'reset-filters': [];
}>();

const title = computed(() => $t('ibe.product-list.empty-state-title', 'No products found'));

const message = computed(() =>
  $t(
    'ibe.product-list.empty-state-description',
    'Unfortunately, we could not find any products matching your criteria. Please try adjusting your filters or search parameters.'
  )
);

const primaryButton = computed(() => ({
  text: $t('ibe.product-list.empty-state-reset', 'Reset filters'),
  onClick: () => emit('reset-filters'),
}));
</script>

<template>
  <BaseErrorState
    icon="icon-info"
    icon-class="bg-gray-600"
    :title="title"
    :message="message"
    :primary-button="primaryButton"
    size="compact"
  />
</template>
